export const REDUCER_NAME = 'state-responsible'

export const STATE_RESPONSIBLE_SELECT = [
    {
        id: 'accounting',
        value: 'Accounting',
    },
    {
        id: 'customer_service',
        value: 'Customer Service',
    },
    {
        id: 'customer_service_sales',
        value: 'Customer Service Sales',
    },
    {
        id: 'customer_service_dental',
        value: 'Customer Service Dental',
    },
    {
        id: 'customer_service_shop',
        value: 'Customer Service Shop Team',
    },
    {
        id: 'first_level_cs',
        value: 'First Level CS',
    },
    {
        id: 'dental_team',
        value: 'Dental Team',
    },
    {
        id: 'CAD',
        value: 'CAD',
    },
    {
        id: 'logistic',
        value: 'Logistic',
    },
    {
        id: 'it',
        value: 'IT',
    },
    {
        id: 'medical',
        value: 'Medical',
    },
    {
        id: 'production',
        value: 'Production',
    },
    {
        id: 'production_external',
        value: 'Production External',
    },
    {
        id: 'retail',
        value: 'Retail',
    },
    {
        id: 'treatment_planning',
        value: 'TreatmentPlaning',
    },
    {
        id: 'not_assigned',
        value: 'Not assigned',
    },
    {
        id: 'end_state',
        value: 'end state',
    },
]





// WEBPACK FOOTER //
// ./src/modules/process/state/state-responsible/const.js